const encoder = new TextEncoder();
const decoder = new TextDecoder();
const keyCache = new Map();
const IV_LENGTH = 12;

function toBase64(uint8Array) {
  return window.btoa(String.fromCharCode(...uint8Array));
}

function fromBase64(base64) {
  return Uint8Array.from(window.atob(base64), c => c.charCodeAt(0));
}

async function deriveKey(secret) {
  if (keyCache.has(secret)) return keyCache.get(secret);

  const keyMaterial = await window.crypto.subtle.digest('SHA-256', encoder.encode(secret));
  const key = await window.crypto.subtle.importKey(
    'raw',
    keyMaterial,
    { name: 'AES-GCM', length: 256 },
    false,
    ['encrypt', 'decrypt']
  );

  keyCache.set(secret, key);
  return key;
}

async function deriveIv(value, secret) {
  const digest = await window.crypto.subtle.digest(
    'SHA-256',
    encoder.encode(`${secret}:${value}`)
  );
  return new Uint8Array(digest).slice(0, IV_LENGTH);
}

export async function secureHash(value, secret) {
  if (!secret) throw new Error('Missing encryption secret');
  const key = await deriveKey(secret);
  const iv = await deriveIv(value, secret);
  const ciphertext = await window.crypto.subtle.encrypt(
    { name: 'AES-GCM', iv },
    key,
    encoder.encode(value)
  );

  return toBase64(new Uint8Array([...iv, ...new Uint8Array(ciphertext)]));
}

export async function secureUnhash(payload, secret) {
  if (!secret) throw new Error('Missing encryption secret');
  const raw = fromBase64(payload);
  const iv = raw.slice(0, IV_LENGTH);
  const data = raw.slice(IV_LENGTH);
  const key = await deriveKey(secret);
  const decrypted = await window.crypto.subtle.decrypt(
    { name: 'AES-GCM', iv },
    key,
    data
  );

  return decoder.decode(decrypted);
}